import * as React from "react";

/**
 * Closes an overlay/dropdown when clicking outside of `ref`.
 * Uses pointerdown + capture for best reliability with portals/touch.
 */
export function useOutsideClose<T extends HTMLElement>(
  ref: React.RefObject<T>,
  isActive: boolean,
  onOutside: () => void
) {
  React.useEffect(() => {
    if (!isActive) return;

    const handler = (e: PointerEvent) => {
      const el = ref.current;
      if (!el) return;

      if (!el.contains(e.target as Node)) onOutside();
    };

    document.addEventListener("pointerdown", handler, true);
    return () => document.removeEventListener("pointerdown", handler, true);
  }, [isActive, onOutside, ref]);
}
